import { MarketplaceCode } from '@backmarket/http-api'

export const CSV_FILE_EXTENSION = ['.csv']
export const ENCODING = 'utf-8'
export const STEPS = {
  choice: 'choice-step',
  import: 'import-step',
  export: 'export-step',
}
export const CSV_DELIMITERS = {
  [MarketplaceCode.EU]: [';', ','],
  [MarketplaceCode.NA]: [',', ';'],
  [MarketplaceCode.AP]: null,
}
export const EXPORT_FORM_VALUE = {
  encoding: ENCODING,
}
